import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

// GUARD
import { AuthGuard } from './shared/auth/auth.guard';

/* COMPONENTS */
import { LoginComponent } from './login/login.component';
import { EnquiryBookComponent } from './internal/enquiry-book/enquiry-book.component';
import { HistoryComponent } from './internal/history/history.component';
import { LogsComponent } from './internal/logs/logs.component';
import { HomeComponent } from './internal/home/home.component';
import { UsersComponent } from './internal/manage-users/users/users.component';
import { GroupsComponent } from './internal/manage-groups/groups/groups.component';
import { CostingToolComponent } from './internal/costing-tool/costing-tool.component';
import { ViewMasterdataComponent } from './internal/view-masterdata/view-masterdata.component';
import { ImportMasterdataComponent } from './internal/import-masterdata/import-masterdata.component';
import { EnquiryBookPricingCommitteeComponent } from './internal/enquiry-book-pricing-committee/enquiry-book-pricing-committee.component';
import { ItdcrComponent } from './internal/itdcr/itdcr.component';

const routes: Routes = [
  { path: '', redirectTo: '/login', pathMatch: 'full' },
  { path: 'login', component: LoginComponent },
  { path: 'enquiry-book', component: EnquiryBookComponent, canActivate: [AuthGuard] },
  { path: 'enquiry-book-pricing-committee', component: EnquiryBookPricingCommitteeComponent, canActivate: [AuthGuard] },
  { path: 'history', component: HistoryComponent, canActivate: [AuthGuard] },
  { path: 'logs', component: LogsComponent, canActivate: [AuthGuard] },
  { path: 'home', component: HomeComponent, canActivate: [AuthGuard] },
  { path: 'users', component: UsersComponent, canActivate: [AuthGuard] },
  { path: 'groups', component: GroupsComponent, canActivate: [AuthGuard] },
  { path: 'costing-tool', component: CostingToolComponent, canActivate: [AuthGuard] },
  { path: 'view-masterdata', component: ViewMasterdataComponent, canActivate: [AuthGuard] },
  { path: 'import-masterdata', component: ImportMasterdataComponent, canActivate: [AuthGuard] },
  { path: 'view-itdcrs', component: ItdcrComponent, canActivate: [AuthGuard] }


  /*{ path: 'charts', component: ChartsComponent, canActivate: [AuthGuard]} */
]

@NgModule({
  imports: [RouterModule.forRoot(routes, { onSameUrlNavigation: 'reload', useHash: true })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
